import { initScrollToTopButton, initMobileNavToggleButton, initMobileNavSubMenuToggleButton, toggleMobileNav, isMobileNavOpen } from './modules/module1';
import '../assets/scss/main.scss';

document.addEventListener('DOMContentLoaded', () => {
  initScrollToTopButton();
  initMobileNavToggleButton();
  initMobileNavSubMenuToggleButton();
});


(function() {
  window.addEventListener('resize', function() {
    console.log("RESIZING");
      const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

      if (isMobileNavOpen() && width > 768) {
        toggleMobileNav();
      }
  });
})();